import { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { createModule, updateModule } from './requestHandlers';
import { verifyRoutePermissions } from '../../globalFunctions';
import { User } from '../../types';
import { useNavigate } from 'react-router-dom';
import { MessageContext } from '../../providers/MessageProvider';
import { ModuleOption } from '../../components/ModuleOption';
import { TextEditor } from '../../components/TextEditor';
import { EditorState } from 'draft-js';
import { convertDraftContentToHTML, convertHtmlToDraftContent } from '../../components/TextEditor/utils';

export default function ModuleForm({ close, editModule }) {
    const [formData, setFormData] = useState({
        name: editModule ? editModule.name : '',
        sort: editModule ? editModule.sort : '',
        modal: editModule ? editModule.modal : '',
        imagem: editModule ? editModule.image : ''
    });
    const navigate = useNavigate();
    const [userAuth, setUserAuth] = useState<User>({} as User);
    const editMode = editModule ? true : false;
    const { setOpenMessage, setMessage } = useContext(MessageContext);
    const [updating, setUpdating] = useState<boolean>(false);
    const [editorState, setEditorState] = useState<EditorState>(EditorState.createEmpty());
  

    // Converter imagem para Base64
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setFormData(prev => ({ ...prev, imagem: reader.result as string }));
        };
        reader.readAsDataURL(file);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const modalContent = convertDraftContentToHTML(editorState);
        try {
            setUpdating(true);
            const sucesso = await createModule(
                userAuth.token,
                formData.name,
                modalContent,
                parseInt(formData.sort),
                formData.imagem
            );
            setOpenMessage(true);
            if (sucesso) {
                setMessage({
                    type: 'success',
                    content: 'Módulo criado com sucesso'
                });
            } else {
                setMessage({
                    type: 'error',
                    content: 'Erro ao criar módulo'
                });
            }
            close();
        } catch {}
        setUpdating(false);
    };

    const handleSubmitEdit = async (e: React.FormEvent) => {
        e.preventDefault();
        setUpdating(true);
        const modalContent = convertDraftContentToHTML(editorState);
        
        const sucesso = await updateModule(
            userAuth.token,
            formData.name,
            modalContent,
            editModule.id,
            parseInt(formData.sort),
            formData.imagem
        );
        setOpenMessage(true);
        if (sucesso) {
            setMessage({
                type: 'success',
                content: 'Módulo editado com sucesso'
            });
        } else {
            setMessage({
                type: 'error',
                content: 'Erro ao editar módulo'
            });
        }
        close();
        setUpdating(false);
    };

    useEffect(() => {
        const user = verifyRoutePermissions(
            ['auth', 'email.verified', 'logicmanager.classes'],
            navigate
        );
        if (typeof user === 'object') {
            setUserAuth(user);
        }
        setEditorState(convertHtmlToDraftContent(editModule?.modal ?? ''));
    }, []);

    return (
        <div className={styles.formContainer}>
            <button onClick={close} className={styles.X}>
                X
            </button>
            <form
                onSubmit={editMode ? handleSubmitEdit : handleSubmit}
                className={styles.moduleForm}
            >
                <h1 className={styles.titleFases}>{editMode ? 'Edição de módulo' : 'Criação de módulo'}</h1>

                <input
                    className={styles.inputNomeForm}
                    type='text'
                    placeholder='Nome'
                    value={formData.name}
                    onChange={e => setFormData(prev => ({ ...prev, name: e.target.value }))}
                    required
                />

                <input
                    className={styles.inputSortForm}
                    type='number'
                    placeholder='Ordem (número)'
                    value={formData.sort}
                    onChange={e => setFormData(prev => ({ ...prev, sort: e.target.value }))}
                    required
                />

                <TextEditor editorState={editorState} setEditorState={setEditorState}/>

                <input type='file' accept='image/*' onChange={handleImageChange} />

                {formData.imagem && (
                    //<img src={formData.imagem} alt="Preview" className={styles.preview} />
                    <ModuleOption
                        style={{ transform: 'scale(1.5)', margin: 'auto',pointerEvents: 'none' }}
                        isCompleted={true}
                        icon={formData.imagem}
                        alt='pré-visualização'
                        moduleLink='/manager/logicmakerModules'
                    />
                )}
                {editMode ? (
                    <button className={styles.criarModulo} type='submit'>
                        {updating ? (
                            <span className={styles.loader}></span>
                        ) : (
                            'Salvar alterações módulo'
                        )}
                    </button>
                ) : (
                    <button className={styles.criarModulo} type='submit'>
                        Criar módulo
                    </button>
                )}
            </form>
        </div>
    );
}
